var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-layout',{attrs:{"id":"reorder-layer1","addClass":"layer_section_renew type-b"}},[_c('popup-reorder-request',{attrs:{"purchase-type":_vm.purchaseType,"req-no":_vm.reqNo,"mypack-name":_vm.mypackName,"isOrderPayment":_vm.isOrderPayment},on:{"dispose":_vm.onDispose}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c99ea8fe","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal-popups/ModalReorderRequest.vue
// module id = null
// module chunks = 